/*
 * Purpose : Component for Login Button
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Aux from '../../../../hoc/Auxilliary/Auxilliary';
import Header from '../../../header/header';
import Footer from '../../footer/footer';
import {IoMdLogIn} from "react-icons/io";
import {Card, CardText, CardTitle, Row, Col} from "reactstrap"
import ToolSalesButton from '../ToolSalesButton/ToolSalesButton';
//import Logo from "../../../../assets/GF_Logo.png";
//import Logo from "../../../../assets/GFonly-ORANGE-letters.png";
import Logo from "../../../../assets/GF2.png";
//import Logo from "../../../../assets/global-foundries-name.png";
import './LoginButton.css';

const loginButton = (props) => {
    return(
        <Aux>
        <Header home={true} login="login" />
        <React.Fragment>
            <CssBaseline />            
            <div className={"loginBtnForm"}>
                <Card body className={"loginCard"}>
                    <CardTitle><img src={Logo} alt="GF logo" className={"logo"} /></CardTitle>
                    <CardText tag="h3">Excess Tools Part List & Accessories Declaration Form</CardText>
                    <Row form style={{ justifyContent: "space-evenly", marginTop:"30px" }}>          
                        <Col md="auto">
                            <ToolSalesButton className={"loginBtn"} onClick={props.clicked} >
                                <IoMdLogIn  style={{ fontSize: "30px"}}/><b>&nbsp;&nbsp;Login</b>
                            </ToolSalesButton></Col>                        
                    </Row>                    
                </Card>    
            </div>
        </React.Fragment>
        <Footer />
      </Aux>
    );
}
export default loginButton;